module.exports = __webpack_public_path__ + "static/media/mini-socioemotional.e9334d93.svg";